import { Component, Input } from '@angular/core';
import { ActionModuleEnum, ActionsService } from '@brafton/angular-framework-library';
import { IBase } from '@brafton/common-framework-library';

@Component({
  selector: 'shared-create-content-button',
  templateUrl: './create-content-button.component.html',
  styleUrls: ['./create-content-button.component.scss'],
  host: { class: 'create-content-button' },
})
export class SharedCreateContentButtonComponent {
  disabled = false;
  @Input() campaign!: IBase;
  expanded = false;

  constructor(private actionsService: ActionsService) {}

  contentImport() {
    this.actionsService.changeActions(
      'ContentUpload',
      ActionModuleEnum.content,
      undefined,
      this.campaign ? this.campaign : undefined,
      undefined,
      undefined,
      'project',
    );
  }

  urlImport() {
    this.actionsService.changeActions(
      'UrlImport',
      ActionModuleEnum.content,
      undefined,
      this.campaign ? this.campaign : undefined,
      undefined,
      undefined,
      'project',
    );
  }
}
